import { Injectable } from '@angular/core';
import { Observable, of, zip } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionPlugin } from '../../../shared/models';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';

@Injectable()
export class InstallationTrainingProvidedPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected factory: InspectionFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public getCustomerAttendees(inspectionId: string, pointId: string): Observable<any[]> {
    return zip(
      this.dataService.getInspectionLevelPlugin(inspectionId, 'installationcustomerattendees'),
      this.dataService.getParrentInspectionLevelPlugin(inspectionId, 'installationcustomercontact')
    ).map(([p, p1]) =>
      p?.config?.Attendees?.length ? [...p?.config?.Attendees] : [...(p1?.config?.CustomerContacts ?? [])]
    );
  }

  public updateTrainingProvided(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    trainingProvided: any
  ): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, trainingProvided).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, trainingProvided: any): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, pointId, pluginId, trainingProvided, 'TrainingProvided').pipe(
      flatMap((plugin: InspectionPlugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
